import {ReactNode} from "react";

export default function ButtonRow({ children }: { children: ReactNode }) {
  return (
    <div className='d-flex gap-2'>
      {children}
    </div>
  )
}